<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <GradeClassStudentSelect @changed="gradeClassStudentChange" />
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { get } from 'lodash'

export default {
  components: {
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: null,
    selectedClass: null,
    selectedStudent: null
  }),
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
